import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { Observable } from 'rxjs/Observable';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';
import { _ } from 'ag-grid-community';

@IonicPage()
@Component({
  selector: 'page-admin-prescription-update',
  templateUrl: 'admin-prescription-update.html',
})
export class AdminPrescriptionUpdatePage {

  user_id: string;
  user_fullname: string;
  clinic_id: string;
  clinic_name: string;
  rx: any;
  original_rx_status: string;
  comment: string = '';
  status_list: any = [{'status':'Queued'},{'status':'Cancelled'},{'status':'On Hold'},{'status':'Fulfilled'}];

  studies: any;
  prescriptions: any;
  public patientStudy: Observable<any[]>;
  public patientPrescriptions: Observable<any[]>;

  constructor(
    private viewCtrl: ViewController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    private auth: AuthProvider,
    private database: DatabaseProvider,
    public utility: UtilityProvider
    ) 
    {
    if (this.navParams.get('rxData')) {
      this.rx = this.navParams.get('rxData');
      this.original_rx_status = this.rx.status;
      console.log('Rx: ', this.rx);
    }

    this.auth.getCurrentUser().then(user => {
      this.user_id = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      console.log(this.user_fullname);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      console.log('Clinic: ', this.clinic_id);
      console.log('Patient ID: ', this.rx.patient_id);
      this.patientStudy = this.database.getStudiesByPatient(this.rx.clinic_id, this.rx.patient_id)
      .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        });

      this.patientStudy.subscribe((studies) => {
        console.log('Studies: ', studies);
        this.studies = studies;
      })

      this.patientPrescriptions = this.database.getPrescriptionsbyPatient(this.rx.clinic_id, this.rx.patient_id).snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });

      this.patientPrescriptions.subscribe((rx) => {
        console.log('Prescriptions: ', rx);
        const newRx = _.filter(rx, (item) => item.id !== this.rx.id && item.studies.length > 0);
        this.prescriptions = newRx
      });
    });
  }

  ionViewDidLoad() {}

  dismiss() {
    this.viewCtrl.dismiss();
  }

  formatdate(date)  {
    return this.utility.formatDate(date, "YYYY MMM DD");
  }

  updatePrescriptionStatus()  {
    let data = this.rx.status;
    let comment = null;
    if (this.comment || this.comment !== '') {
      comment = this.comment;
    }
    console.log('Comment: ', comment);
    this.database.updatePrescriptionAndStudies(
      data,
      comment,
      this.rx.id,
      this.rx.clinic_id,
      this.rx.patient_id,
      this.user_id,
      this.user_fullname,
      this.studies
    ).then(()=>{
      this.dismiss();
    })
    .catch((error)=> {
      console.log('Error updating status: ', error);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-prescription-update/admin-prescription-update.ts